var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSocialInvision(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6081_20271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9944 23V22.9991H23V14.8633C23 10.8832 22.1431 7.8172 17.4901 7.8172C15.2533 7.8172 13.7522 9.04469 13.1394 10.2084H13.0747V8.18877H8.6629V22.9991H13.2568V15.6656C13.2568 13.7347 13.6228 11.8676 16.014 11.8676C18.3701 11.8676 18.4052 14.0711 18.4052 15.7894V23H22.9944Z",
    fill: "#3E4756"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.18268 8.18988H5.78208V23.0002H1.18268V8.18988Z",
    fill: "#3E4756"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.48029 0.816406C2.0097 0.816406 0.816406 2.0097 0.816406 3.48029C0.816406 4.95087 2.0097 6.16912 3.48029 6.16912C4.95087 6.16912 6.14417 4.95087 6.14417 3.48029C6.14324 2.0097 4.94995 0.816406 3.48029 0.816406V0.816406Z",
    fill: "#3E4756"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6081_20271"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.1836,
    height: 22.1836,
    fill: "white",
    transform: "translate(0.816406 0.816406)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSocialInvision);
export default __webpack_public_path__ + "static/media/IconSocialInvision.3e249e7d.svg";
export { ForwardRef as ReactComponent };